export default {
  type: "object",
  properties: {
    id: {
      type: "integer",
      example: 1
    },
    name: {
      type: "string",
      description: "not localized unique label",
      example: "EU"
    }
  }
};
